import React, { useMemo } from "react";
import { Workflow } from "../workflow/workflow";
import { ChannelPerformance } from "../channel/channel";
import { ListsOverview } from "../list-overview/list-overview";
import { MetricCard } from "../shared/metricCard";
import { useDashboardData } from "../../hooks";
import { getIconColor, getIconComponent, titleMap } from "../../utils";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";

export const Landing: React.FC = () => {
  const {
    overview,
    listOverview,
    channelStats,
    channelPerformance,
    workflowPerformance,
    workflowStats,
  } = useDashboardData();

  const overviewArray = useMemo(() => {
    return overview.data
      ? Object.entries(overview.data).map(([key, value]) => ({
          key,
          value,
          channelType: key,
        }))
      : [];
  }, [overview]);

  return (
    <div className="space-y-6 animate-fade-in">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="page-title">Dashboard</h1>
          <p className="page-subtitle">
            Monitor and manage utility communications
          </p>
        </div>
      </div>

      {/* Channel Stats Overview */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
        {overviewArray.length > 0 ? (
          overviewArray.slice(0, 5).map((card, index) => {
            const IconComponent = getIconComponent(card.channelType);
            const iconColor = getIconColor(card.channelType);
            const customIconColorClass =
              index === 2 || index === 3 ? "text-green-500" : "text-primary";

            return (
              // <MetricCard
              //   position="top"
              //   key={index}
              //   title={titleMap[card.key] || card.key}
              //   value={card.value.toString()}
              //   change="1"
              //   trend="up"
              //   icon={IconComponent}
              //   iconColor={customIconColorClass}
              //   variant="white"
              // />
              <QuickStatsCard title={titleMap[card.key] || card.key} count={card.value.toString()} icon={<IconComponent />}  />
            );
          })
        ) : (
          <p className="text-muted-foreground col-span-full">
            No channel stats available.
          </p>
        )}
      </div>

      {/* Performance & List Overview */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <ChannelPerformance
          data={channelStats.data}
          overview={channelPerformance.data}
        />
        <ListsOverview data={listOverview.data} />
      </div>

      {/* Workflow Section */}
      <Workflow data={workflowPerformance.data} statData={workflowStats.data} />
    </div>
  );
};
